export default __webpack_public_path__ + "static/media/bcb_1.a8f5bf86.jpg";